import { BaseContainerModel } from "../../../base-container.model";
import { bl_fi_generic_doc_hdr_RowInterface, bl_fi_generic_doc_line_RowInterface, bl_mrp_pick_pack_queue_RowInterface } from "../../../../dbschema";

export class MrpPickPackQueueGenDocContainerModel extends BaseContainerModel {
  bl_mrp_pick_pack_queue: bl_mrp_pick_pack_queue_RowInterface;
  bl_fi_generic_doc_hdrs: bl_fi_generic_doc_hdr_RowInterface[] = [];
  bl_fi_generic_doc_lines: bl_fi_generic_doc_line_RowInterface[] = [];
}